import { collection, doc } from "firebase/firestore";

import { auth, db } from "@/lib/firebase";

/**
 * Reading another person's profile.
 *
 * users/{uid} (email, phone, last login, billing...) is readable only by its
 * owner and admins. Everyone else is shown publicProfiles/{uid}: an allowlisted
 * copy (names, username, photo, roles, bio) kept in sync by the
 * syncPublicProfile Cloud Function.
 */

/** Your own full document, or someone else's public profile. */
export function profileDocRef(uid: string) {
  return uid && uid === auth.currentUser?.uid ? doc(db, "users", uid) : doc(db, "publicProfiles", uid);
}

/** Search and list other people here, never in `users`. */
export function publicProfilesCollection() {
  return collection(db, "publicProfiles");
}
